import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { DownArrow } from 'components/CommonIcons';

import * as styles from './CollapsibleButton.scss';

/**
 * @class CollapisbleButton
 * @classdesc Reusable CollapsibleButton Component
 * @property {Object} state
 * @example ./CollapisbleButton.md
 */
export default class CollapsibleButton extends Component {
  static propTypes = {
    displayValue: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    arrowClassName: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  };

  static defaultProps = {
    arrowClassName: null,
    className: null,
    size: 'LARGE',
    style: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = () => {
    const { onClick } = this.props;

    this.setState(prevState => ({ open: !prevState.open }));
    return onClick();
  };

  render() {
    const { displayValue, arrowClassName, className, size, style } = this.props;
    const { open } = this.state;

    const defaultButtonClass = size === 'LARGE'
      ? styles.collapsibleBtnLarge
      : styles.collapsibleBtn;
    const defaultTitleClass = size === 'LARGE'
      ? styles.collapsibleTitleLarge
      : styles.collapsibleTitle;

    return (
      <div
        className={classNames(
          defaultButtonClass,
          { [styles.collapsibleBtnOpen]: open },
          className
        )}
        style={style}
        onClick={this.handleClick}
      >
        <div className={defaultTitleClass}>{displayValue}</div>
        <div className={classNames(
          styles.arrow,
          { [styles.arrowLarge]: size === 'LARGE' },
          arrowClassName
        )}>
          <DownArrow />
        </div>
      </div>
    );
  }
}
